import React, { FunctionComponent, useContext } from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { AppContext } from '../../context'
import { BodyTextSize } from '../../styles/typeStyles'
import { Banner } from '../banner/Banner'

const StyledBanner = styled(Banner)({
  marginTop: 0,
})

export interface BenefitsExtensionBannerProps {
  effectiveDate?: Date
  extensionCustomerDisplayName?: string
}

export const BenefitsExtensionBanner: FunctionComponent<BenefitsExtensionBannerProps> = ({
  effectiveDate,
  extensionCustomerDisplayName,
}) => {
  const { isBenefitsExtensionBannerDisplayed } = useContext(AppContext)
  const { formatMessage, formatDate } = useIntl()
  const { colors } = useTheme()

  // Calculate the beginning of next year if no effectiveDate is provided
  const getEffectiveDate = () => {
    if (effectiveDate) {
      return effectiveDate
    }
    const nextYear = new Date().getFullYear() + 1
    return new Date(nextYear, 0, 1) // January 1st of next year
  }

  const bannerMessage = formatMessage(
    {
      defaultMessage:
        'Beginning {date}, {customerName} employees and their dependents will have access to mental health care through Lyra Health.',
      description: 'Banner message informing users about the extension of their benefits',
    },
    {
      date: formatDate(getEffectiveDate(), { day: 'numeric', month: 'long', year: 'numeric' }),
      customerName: extensionCustomerDisplayName,
    },
  )

  return (
    <StyledBanner
      show={isBenefitsExtensionBannerDisplayed ?? false}
      bannerContent={
        <BodyText
          textAlign='center'
          color={colors.components.alertBanner.calm.text}
          size={BodyTextSize.LARGE}
          text={bannerMessage}
        />
      }
      backgroundColor={colors.backgroundActive}
    />
  )
}
